export default __webpack_public_path__ + "805fee15e0580ac5c3847de79e122b44.svg";